import { Button, ButtonStyles, Icon, Icons } from '@silverfort/sf-components';
import { useState } from 'react';
import InventoryActiveDirectory from './InventoryActiveDirectory';
import { useTowerLayout } from '../../TowerLayout/TowerLayoutProvider';
import { ReactComponent as GetCloud } from './assets/get_cloud.svg';

const ON_PREM_TABS = [{ value: 0, title: 'Active Directory' }];

const GET_CLOUD_URL = 'https://www.silverfort.com/cloud-platform-signup/?utm_source=PQL&utm_content=main';

const InventoryOnPrem = ({ inFrame = false, inventoryConfig, updateInventoryConfig, shouldShowGetCloud = false }) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const { setHideHeader } = useTowerLayout();

    const hideCloudTeaser = inventoryConfig?.hideCloudTeaser || false;

    inFrame && setHideHeader(false);
    return (
        <div
            className={`font-sf text-sf-gray-800 text-12 ${
                inFrame ? 'w-screen' : 'w-[calc(100vw-64px)] ml-16'
            } flex bg-sf-white mt-16 h-[calc(100vh-64px)]`}>
            <div className="h-full w-50 min-w-50 border-r border-sf-gray-100 p-4">
                <div className="w-full flex flex-col gap-2">
                    <div className="h-6 text-medium flex gap-1 font-bold">
                        <Icon icon={Icons.Server} /> On-prem
                    </div>
                    <div
                        onClick={() => setSelectedTab(ON_PREM_TABS[0].value)}
                        className={`h-12 rounded p-2 flex items-center gap-2 ${
                            selectedTab === ON_PREM_TABS[0].value ? 'bg-sf-primary-100' : 'cursor-pointer'
                        }`}>
                        <div className="h-8 w-8 rounded flex items-center justify-center bg-sf-white">
                            <Icon size={24} icon={Icons.ActiveDirectory} />
                        </div>
                        {ON_PREM_TABS[0].title}
                    </div>
                    {shouldShowGetCloud && hideCloudTeaser && (
                        <>
                            <div className="h-6 text-medium flex gap-2 py-1 px-2">
                                <Icon icon={Icons.Cloud} /> Cloud
                            </div>
                            <Button
                                text={'Get Cloud'}
                                className="w-full"
                                buttonStyle={ButtonStyles.Primary}
                                onClick={() => window.open(GET_CLOUD_URL, '_blank')}
                            />
                        </>
                    )}
                </div>
                {shouldShowGetCloud && !hideCloudTeaser && (
                    <div className="flex flex-col border border-sf-gray-100 rounded-lg w-[calc(100%-20px)] h-fit gap-4 px-4 mx-2.5 mt-4 py-8 font-sf shadow-[0_2px_4px_0_rgba(0,0,0,0.10)]">
                        <div className="text-16 font-medium">Get full cloud visibility</div>
                        <GetCloud className="w-full h-auto" />
                        <div className="text-12 leading-[18px]">
                            Your current Silverfort license is for on-prem access only. Click Get Cloud Access to get
                            full cloud visibility
                        </div>
                        <div className="flex flex-col gap-2 mt-[62px]">
                            <Button
                                text={'Get Access'}
                                buttonStyle={ButtonStyles.PrimarySolid}
                                className="w-full"
                                onClick={() => window.open(GET_CLOUD_URL, '_blank')}
                            />
                            <Button
                                text={'Not Now'}
                                buttonStyle={ButtonStyles.GhostSolid}
                                className="w-full"
                                onClick={updateInventoryConfig({ ...inventoryConfig, hideCloudTeaser: true })}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className="w-[calc(100vw-264px)]">
                {selectedTab === ON_PREM_TABS[0].value && <InventoryActiveDirectory />}
            </div>
        </div>
    );
};

export default InventoryOnPrem;
